import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

////////////////////// DESIGNATIONS ///////////////////////////
export const getAllDesignations = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.DESIGNATION}/list/${tenantId}`);
    return response.data.data;
}

export const deleteDesignation = async (designationID: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.DESIGNATION}/${designationID}`);
    return response.data.data;
}

export const editDesignation = async (name: string, tenantId: string, designationID: number) => {
    const data = {
        "name": name,
        "tenant_id": tenantId
    }
    const response = await api.put(`${API_ROUTES.MASTER.DESIGNATION}/${designationID}`, data);
    return response;
}

export const createNewDesignation = async (name: string, tenantId: string, rank: number) => {
    const data = {
        "name": name,
        "tenant_id": tenantId,
        "rank": rank
    }
    const response = await api.post(`${API_ROUTES.MASTER.DESIGNATION}`, data);
    return response;
}

////////////////////// COUNTRY ///////////////////////////
export const createNewCountry = async (name: string, tenantId: string, lat: string, long: string) => {
    const data = {
        "name": name,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.post(`${API_ROUTES.MASTER.COUNTRY}`, data);
    return response;
}

export const editCountry = async (name: string, tenantId: string, lat: string, long: string, countryId: number) => {
    const data = {
        "name": name,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.put(`${API_ROUTES.MASTER.COUNTRY}/${countryId}`, data);
    return response;
}

export const deleteCountry = async (countryId: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.COUNTRY}/${countryId}`);
    return response.data.data;
}

export const getAllCountries = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.COUNTRY}/list/${tenantId}`);
    return response.data.data;
}

////////////////////// ZONES ///////////////////////////
export const getAllZones = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.ZONE}/list/${tenantId}`);
    return response.data.data;
}

export const editZone = async (name: string, tenantId: string, lat: string, long: string, countryId: string, zoneId: string) => {
    const data = {
        "name": name,
        "country_id": countryId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.put(`${API_ROUTES.MASTER.ZONE}/${zoneId}`, data);
    return response;
}

export const createNewZone = async (name: string, tenantId: string, lat: string, long: string, countryId: string) => {
    const data = {
        "name": name,
        "country_id": countryId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.post(`${API_ROUTES.MASTER.ZONE}`, data);
    return response;
}

export const deleteZone = async (zoneId: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.ZONE}/${zoneId}`);
    if (response.data.success) return true;
    return false;
}

////////////////////// HEADQUARTER ///////////////////////////
export const getAllHeadquarters = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.HEADQUARTER}/list/${tenantId}`);
    return response.data.data;
}

export const deleteHeadquarter = async (headquarterId: number) => {
    try {
        const response = await api.delete(`${API_ROUTES.MASTER.HEADQUARTER}/${headquarterId}`);
        if (response.data.success) return true;
        return false;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to delete headquarter.';
        throw new Error(message);
    }
}

export const editHeadquarter = async (name: string, tenantId: string, lat: string, long: string, zoneId: string, headquarterId: string) => {
    const data = {
        "name": name,
        "zone_id": zoneId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.put(`${API_ROUTES.MASTER.HEADQUARTER}/${headquarterId}`, data);
    return response;
}

export const createNewHeadquarter = async (name: string, tenantId: string, lat: string, long: string, zoneId: string) => {
    const data = {
        "name": name,
        "zone_id": zoneId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long
    }
    const response = await api.post(`${API_ROUTES.MASTER.HEADQUARTER}`, data);
    return response;
}
export const getHeadquarterByTenantZone = async (tenantId: string, zoneId: number) => {
    const response = await api.get(`${API_ROUTES.HEADQUARTER_BY_TENANT_ZONE}/${tenantId}/${zoneId}`);
    return response.data.data;
}


////////////////////// LOCATION ///////////////////////////
export const getAllLocations = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.LOCATION}/list/${tenantId}`);
    return response.data.data;
}

export const deleteLocation = async (locationId: number) => {
    try {
        const response = await api.delete(`${API_ROUTES.MASTER.LOCATION}/${locationId}`);
        if (response.data.success) return true;
        return false;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to delete location.';
        throw new Error(message);
    }
}

export const editLocation = async (name: string, tenantId: string, lat: string, long: string, headquarterId: string, location_id: string, isHq: boolean = false) => {
    const data = {
        "name": name,
        "head_quarter_id": headquarterId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long,
        "is_hq": isHq
    }
    const response = await api.put(`${API_ROUTES.MASTER.LOCATION}/${location_id}`, data);
    return response;
}

export const createNewLocation = async (name: string, tenantId: string, lat: string, long: string, headquarterId: string, isHq: boolean = false) => {
    const data = {
        "name": name,
        "head_quarter_id": headquarterId,
        "tenant_id": tenantId,
        "latitude": lat,
        "longitude": long,
        "is_hq": isHq
    }
    const response = await api.post(`${API_ROUTES.MASTER.LOCATION}`, data);
    return response;
}



////////////////////// SALT ///////////////////////////
export const getAllSalts = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.SALT}/list/${tenantId}`);
    return response.data.data;
}

export const deleteSalt = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.SALT}/${id}`);
    if (response.data.success) return true;
    return false;
}

export const editSalt = async (id: number, tenantId: string, name: string) => {
    const data = {
        "tenant_id": tenantId,
        "name": name,
    }
    const response = await api.put(`${API_ROUTES.MASTER.SALT}/${id}`, data);
    return response;
}

export const createNewSalt = async (tenantId: string, name: string) => {
    const data = {
        "tenant_id": tenantId,
        "name": name,
    }
    const response = await api.post(`${API_ROUTES.MASTER.SALT}`, data);
    return response;
}



////////////////////// ROUTE ///////////////////////////
export interface RoutePaginationMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

export interface RouteServerFilters {
    head_quarter_id?: number;
    zone_id?: number;
    search?: string;
}

export const getAllRoutes = async (
    tenantId: string,
    page: number = 1,
    perPage: number = 15,
    filters: RouteServerFilters = {}
): Promise<{ data: any[]; pagination: RoutePaginationMeta }> => {
    const response = await api.get(`${API_ROUTES.MASTER.ROUTE}/list/${tenantId}`, {
        params: { page, per_page: perPage, ...filters },
    });
    return {
        data: response.data.data,
        pagination: response.data.pagination,
    };
}

export const createNewRoute = async (
    tenantId: string,
    zoneId: number,
    fromLocationId: number,
    toLocationId: number,
    mode: string,
    distance: number,
    citiesInRoute: string
) => {
    const data: any = {
        tenant_id: tenantId,
        zone_id: zoneId,
        from_location_id: fromLocationId,
        to_location_id: toLocationId,
        mode,
        distance,
    };
    if (citiesInRoute) data.cities_in_route = citiesInRoute;
    const response = await api.post(API_ROUTES.MASTER.ROUTE, data);
    return response;
}

export const editRoute = async (
    id: number,
    tenantId: string,
    zoneId: number,
    fromLocationId: number,
    toLocationId: number,
    mode: string,
    distance: number,
    citiesInRoute: string
) => {
    const data: any = {
        tenant_id: tenantId,
        zone_id: zoneId,
        from_location_id: fromLocationId,
        to_location_id: toLocationId,
        mode,
        distance,
    };
    if (citiesInRoute) data.cities_in_route = citiesInRoute;
    const response = await api.put(`${API_ROUTES.MASTER.ROUTE}/${id}`, data);
    return response;
}

export const deleteRoute = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.ROUTE}/${id}`);
    if (response.data.success) return true;
    return false;
}

////////////////////// SFC ///////////////////////////
export const getAllSfcs = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.SFC}/list/${tenantId}`);
    return response.data.data;
}

export const exportSfc = async (tenantId: string): Promise<void> => {
    const response = await api.get(`${API_ROUTES.MASTER.SFC}/export/${tenantId}`, {
        responseType: 'arraybuffer',
    });
    const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `sfc_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

export const importSfc = async (tenantId: string, file: File) => {
    const formData = new FormData();
    formData.append('tenant_id', tenantId);
    formData.append('file', file);
    const response = await api.post(`${API_ROUTES.MASTER.SFC}/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
}

export const createNewSfc = async (tenantId: string, zoneId: number, routeId: number, employeeId: number | null, fare: number) => {
    const data: any = { tenant_id: tenantId, zone_id: zoneId, route_id: routeId, fare };
    if (employeeId) data.employee_id = employeeId;
    const response = await api.post(API_ROUTES.MASTER.SFC, data);
    return response;
}

export const editSfc = async (id: number, tenantId: string, zoneId: number, routeId: number, employeeId: number | null, fare: number) => {
    const data: any = { tenant_id: tenantId, zone_id: zoneId, route_id: routeId, fare };
    if (employeeId) data.employee_id = employeeId;
    const response = await api.put(`${API_ROUTES.MASTER.SFC}/${id}`, data);
    return response;
}

////////////////////// DAILY ALLOWANCE ///////////////////////////
export const getAllDailyAllowances = async (tenantId: string | number) => {
    const response = await api.get(`${API_ROUTES.MASTER.DAILY_ALLOWANCE}/list/${tenantId}`);
    return response.data.data;
}

export const createDailyAllowance = async (
    tenantId: string | number,
    designationId: number,
    headQuarterAmount: number,
    exAmount: number,
    outAmount: number,
    km: number,
    taType: number = 1
) => {
    const response = await api.post(API_ROUTES.MASTER.DAILY_ALLOWANCE, {
        tenant_id: tenantId,
        designation_id: designationId,
        head_quarter_amount: headQuarterAmount,
        ex_amount: exAmount,
        out_amount: outAmount,
        km,
        ta_type: taType,
    });
    return response;
}

export const updateDailyAllowance = async (
    id: number,
    headQuarterAmount: number,
    exAmount: number,
    outAmount: number,
    km: number,
    taType: number = 1
) => {
    const response = await api.put(`${API_ROUTES.MASTER.DAILY_ALLOWANCE}/${id}`, {
        head_quarter_amount: headQuarterAmount,
        ex_amount: exAmount,
        out_amount: outAmount,
        km,
        ta_type: taType,
    });
    return response;
}

export const deleteDailyAllowance = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.DAILY_ALLOWANCE}/${id}`);
    return response;
}

export const deleteSfc = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.SFC}/${id}`);
    if (response.data.success) return true;
    return false;
}

////////////////////// MEDICINE ///////////////////////////
export const getAllMedicines = async (tenantId: string) => {
    const response = await api.get(`${API_ROUTES.MASTER.MEDICINE}/list/${tenantId}`);
    return response.data.data;
}

export const deleteMedicine = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.MASTER.MEDICINE}/${id}`);
    if (response.data.success) return true;
    return false;
}

export const editMedicine = async (id: number, tenantId: string, salt_id: string, name: string) => {
    const data = {
        "tenant_id": tenantId,
        "salt_id": salt_id,
        "name": name,
    }
    const response = await api.put(`${API_ROUTES.MASTER.MEDICINE}/${id}`, data);
    return response;
}

export const createNewMedicine = async (tenantId: string, salt_id: string, name: string) => {
    const data = {
        "tenant_id": tenantId,
        "salt_id": salt_id,
        "name": name,
    }
    const response = await api.post(`${API_ROUTES.MASTER.MEDICINE}`, data);
    return response;
}